import Mixin from '../Mixin';
import FDictionaryHotel from '@/modules/Dictionary/Hotel/Select';
import FDictionaryRoomType from '@/modules/Dictionary/RoomType/Select';
import FDictionaryRoomCategory from '@/modules/Dictionary/RoomCategory/Select';
import FDictionaryRoomAccommodation from '@/modules/Dictionary/RoomAccommodation/Select';
import FDictionaryBoarding from '@/modules/Dictionary/Boarding/Select';

import component from './component.vue';

export default class extends Mixin {
  component = component;

  hotel = new FDictionaryHotel({
    label: 'Отель',
    required: true,
  });

  roomType = new FDictionaryRoomType({
    label: 'Тип номера',
  });

  roomCategory = new FDictionaryRoomCategory({
    label: 'Категория номера',
  });

  roomAccommodation = new FDictionaryRoomAccommodation({
    label: 'Тип размещения',
  });

  boarding = new FDictionaryBoarding({
    label: 'Тип питания',
  });

  constructor(props) {
    super(props);
    this.setItems([
      ['hotel', this.hotel],
      ['roomType', this.roomType],
      ['roomCategory', this.roomCategory],
      ['roomAccommodation', this.roomAccommodation],
      ['boarding', this.boarding],
    ]);
    this.hotel.city = this.city;
    this.service.set({
      value: 3,
      label: 'Отель',
    });
  }


  set(value = {}) {
    super.set(value);
    this.__set('hotel', value.hotel, null);
    this.__set('roomType', value.roomType, null);
    this.__set('roomCategory', value.roomCategory, null);
    this.__set('roomAccommodation', value.roomAccommodation, null);
    this.__set('boarding', value.boarding, null);
    return this;
  }

  toString() {
    return this.hotel.toString();
  }

  submit() {
    return super.submit()
      .then((data) => {
        this.name = this.hotel.toLabel();
        return data;
      });
  }
}
